import apiService from './api.js';

export const reportsService = {
  // Dashboard e KPIs
  async getDashboardMetrics() {
    try {
      const response = await apiService.get('/reports/dashboard');
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  async getKPIData() {
    try {
      const response = await apiService.get('/reports/kpis');
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  // Relatórios específicos
  async getOriginationReport(filters = {}) {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const response = await apiService.get(`/reports/origination?${queryParams}`);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  async getPortfolioReport(filters = {}) {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const response = await apiService.get(`/reports/portfolios?${queryParams}`);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  async getPerformanceReport(filters = {}) {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const response = await apiService.get(`/reports/performance?${queryParams}`);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  // Exportação
  async exportReport(reportType, filters = {}) {
    try {
      const queryParams = new URLSearchParams({ ...filters, format: 'excel' }).toString();
      const response = await apiService.get(`/reports/${reportType}/export?${queryParams}`);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  }
};